export default "__VITE_ASSET__CJ0Nxk5s__"